import React from 'react';
import Highcharts from 'highcharts';
import sankey from 'highcharts/modules/sankey';
import dependencyWheel from 'highcharts/modules/dependency-wheel';
import useChart from '../../../../hooks/generic/charts/useChart';

// We need to explicitly initialize this modules as they are not part of core Highcharts
// Sankey is used for linking nodes and Dependency Wheel is built on top of Sankey
sankey(Highcharts);
dependencyWheel(Highcharts);

const DependencyWheel = (props) => {
  const { backgroundColor, exportData } = props;
  
  const defaultChartOptions = {
    chart: {
      type: 'dependencywheel',
      height: 300,
      width: 300,
      backgroundColor: backgroundColor,
      events: {
        ...(exportData && { exportData })
      }
    },
    title: {
      text: null
    },
    tooltip: {
      outside: true,
      pointFormatter: function() {
        const truncateText = (text, maxLength = 300) => {
          if (!text || text.length <= maxLength) return text;
          return text.substring(0, maxLength) + '...';
        };
        const fromText = truncateText(this.from);
        const toText = truncateText(this.to);
        return `${fromText}, ${toText}: <b>${this.weight}</b>`;
      },
      headerFormat: ''
    },
    accessibility: {
      point: {
        valueDescriptionFormat: '{index}. From {point.from} to {point.to}: {point.weight}.'
      }
    },
    plotOptions: {
      dependencywheel: {
        nodeWidth: 15,
        showInLegend: false,
        borderWidth: 0,
        dataLabels: {
          enabled: false
        },
        states: {
          hover: {
            dataLabels: {
              enabled: true 
            }
          }
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      filename: "network_connection_chart",
      chartOptions: {
        chart: {
          backgroundColor: 'white'
        },

        plotOptions: {
          dependencywheel: {
            dataLabels: {
              enabled: true,
              allowOverlap: false,
              useHTML: true,
              style: {
                fontSize: '6px',
                textOutline: '1px contrast',
                width: '80px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }
            }
          }
        }
      }
    }

  };

  const [HighchartsComponent, highchartsOptions] = useChart({
    chartOptions: {
      defaultOptions: defaultChartOptions,
      primaryOptions: props.chartOptions
    },
    configs: props.configs
  });

  return(
    <div>
      <HighchartsComponent { ...highchartsOptions } callback={ props.callbackFn } />
    </div>
  )
}

export default DependencyWheel;